"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgQuestionSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.617 20.427l.202.023a1.739 1.739 0 011.435 1.811l-.024.202-.017.099a1.738 1.738 0 01-3.448-.4l.024-.2.017-.1a1.739 1.739 0 011.811-1.435zM11.518 0c3.609 0 6.519 3.014 6.519 6.704 0 2.1-.705 3.69-2.307 5.106l-.332.281c-.358.29-.676.591-.957.904-1.186 1.32-1.61 2.634-1.626 3.622l.003.222a1.304 1.304 0 01-2.57.4l-.032-.23-.003-.049c-.025-.55.042-1.268.272-2.099.347-1.247.998-2.475 2.017-3.61.249-.276.517-.544.807-.804l.448-.383c1.23-.994 1.672-1.91 1.672-3.36 0-2.27-1.763-4.097-3.91-4.097-2.201 0-3.912 1.688-3.912 3.911a1.304 1.304 0 01-2.607 0C5 2.848 7.886 0 11.518 0z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgQuestionSolid;
exports.default = _default;